import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'

// import { Header } from '~/layout'
// import Controls from './Controls'
// import DataMap from './DataMap'
// import DataStationSearch from '~/components/DataStationSearch'
// import DataDateSearch from '~/components/DataDateSearch'
import {
  // AppLayout,
  MainLayout,
  MapLayout,
  // SearchLayout,
  ContentLayout
  // FooterLayout
} from '~/components/styles'
import can from '~/utils/can'

const App = ({ view, user }) => {
  return (
    can(user.profile, 'view_optimization')
      ? <MainLayout>
        <MapLayout>

        </MapLayout>
        <ContentLayout mode={view.mode}>
optimization
        </ContentLayout>
      </MainLayout>
      : <div>
    UNAUTHORIZED
      </div>
  )
}
export default compose(
  inject('view'),
  inject('user'),
  observer
)(App)



// WEBPACK FOOTER //
// ./src/modules/Optimization/index.js